import "./styles.css";
import { Grid, Box, Container } from "@mui/material";
import { useFormik } from "formik";
import { styled } from "@mui/material/styles";
import { setLocalStorageData } from "../../../../shared/utils/localStorage";
import { LoadingButton } from "@mui/lab";
import InputTextfield from "../../../../shared/components/textField";
import { useContext, useState } from "react";
import { SnackBarAlertContext } from "../../../../contexts/SnackbarContext";
import { useNavigate } from "react-router-dom";
import { customizeValidationSchema } from "./customSchema";
import { NavLink } from "react-router-dom";
import MenuContainer from "../../../../shared/components/auth/menuContainer";
import LoginBG from "../../../../assets/img/login-svg.svg";
import LoginLine from "../../../../assets/img/login-line.svg";

const StyledMenuBg = styled(Box)(
  ({ theme }) => `
    top: 0;
    background: transparent;
    padding: 0 10%;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: space-between;
  h1 {
    color: rgba(15, 41, 85, 0.20);
    font-family: Poppins;
    font-size: 100px;
    font-style: normal;
    font-weight: 275;
    line-height: normal;
    margin-top: 0;
    }
    img {
      max-width: 100%;
      height: auto;
      display: block;
    }
  `
);

const Login = (props: any) => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState<boolean>(false);
  const snackBarAlertContext = useContext(SnackBarAlertContext);
  const textFields = [
    {
      id: "login-email",
      name: "email",
      placeholder: "Enter your email",
      type: "text",
      required: true,
      label: "Email",
    },
    {
      id: "login-password",
      name: "password",
      placeholder: "Enter your password",
      type: "password",
      required: true,
      label: "Password",
    },
  ];
  const loginForm = useFormik({
    initialValues: {
      email: "",
      password: "",
    },
    validationSchema: customizeValidationSchema,
    onSubmit: async (loginData: any) => {
      setLoading(true);
      const response: any = await fetch(
        process.env.REACT_APP_API_URL + "admin/login",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(loginData),
        }
      );
      if (response?.ok) {
        setLoading(false);
        const token = response.headers.get("token");
        const responseData = await response.json();
        const { email, admin } = responseData?.data || {};
        setLocalStorageData("token", token);
        setLocalStorageData("user-name", email);
        setLocalStorageData("name", admin?.fullName);
        navigate("/dashboard");
      } else {
        setLoading(false);
        const error = await response.json();
        snackBarAlertContext.set({
          status: true,
          type: "error",
          message: error?.message,
        });
      }
    },
  });
  return (
    <>
      <Box sx={{ height: "100%", width: "100%" }}>
        <Container>
          <Grid
            container
            sx={{ justifyContent: "center", alignItems: "center" }}
          >
            <Grid item md={3}>
              <MenuContainer />
              <StyledMenuBg>
                <h1>Login</h1>
              </StyledMenuBg>
            </Grid>
            <Grid item md={0.75}>
              <img style={{ padding: "0 12px" }} src={LoginLine} alt="Logo" />
            </Grid>
            <Grid item md={3}>
              <form
                onSubmit={loginForm.handleSubmit}
                autoComplete="off"
                className="loginForm"
              >
                {textFields.map((field: any, index: number) => {
                  return (
                    <Grid sx={{ mt: 1 }} key={index}>
                      <InputTextfield
                        form={loginForm}
                        fieldProps={field}
                        key={index}
                        className="customInput"
                      />
                    </Grid>
                  );
                })}
                <Grid
                  sx={{
                    mt: 1,
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                  container
                  spacing={1}
                >
                  <Grid item md={8}>
                    <NavLink
                      to="/forgot-password"
                      className="forgot-password-link"
                      aria-label="Forgot your password? Click here to reset it."
                    >
                      Forgot password?
                    </NavLink>
                  </Grid>
                  <Grid item md={4}>
                    <LoadingButton
                      loading={loading}
                      variant="contained"
                      type="submit"
                      fullWidth
                      size="small"
                      aria-label="Click here to login."
                    >
                      Login
                    </LoadingButton>
                  </Grid>
                </Grid>
              </form>
            </Grid>
          </Grid>
        </Container>
      </Box>
    </>
  );
};
export default Login;
